import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getIssuersList } from 'api/License';

export const useGetIssuersList = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  const navigate = useNavigate();
  return useQuery(['license-issuers', ...dependencies], () => getIssuersList(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...options
  });
};
